/* Shopify-native localization discovery: recommend, never force redirect. */
(() => {
 'use strict';
 const preferenceKey='suhue-localization-choice-v1';
 const readPreference=()=>{try{return JSON.parse(localStorage.getItem(preferenceKey)||'null')}catch{return null}};
 const remember=()=>{try{localStorage.setItem(preferenceKey,JSON.stringify({at:Date.now()}))}catch{}};
 const defaultOccasion=country=>{
  if(['AE','SA','QA','KW','BH','OM','JO','LB','IQ','EG'].includes(country))return 'architecture';
  if(['VN','TH','SG','MY','ID','BN','LA','KH','MM','TL'].includes(country))return 'lanterns';
  return 'christmas';
 };
 function guide(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const controls=[...root.querySelectorAll('[data-sb-occasion]')];
  const select=key=>{
   controls.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.sbOccasion===key)));
   root.querySelectorAll('[data-sb-occasion-panel]').forEach(panel=>panel.hidden=panel.dataset.sbOccasionPanel!==key);
  };
  // A starting suggestion, not a restriction or a claim about a visitor's beliefs.
  select(defaultOccasion(document.querySelector('[data-sb-international]')?.dataset.country));
  controls.forEach(button=>button.addEventListener('click',()=>select(button.dataset.sbOccasion)));
 }
 async function preferences(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const form=root.querySelector('form'),details=root.querySelector('details');
  const country=form?.elements.country_code,language=form?.elements.language_code;
  if(!form||!country||!language)return;
  form.addEventListener('submit',remember);
  const choice=readPreference();if(choice?.at>Date.now()-30*24*60*60*1000)return;
  const valid=(select,value)=>[...select.options].some(option=>option.value===value);
  const params=new URLSearchParams({'country[enabled]':'true','country[exclude]':root.dataset.country,'language[enabled]':'true','language[exclude]':root.dataset.language});
  try{
   const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
   const response=await fetch(base+'browsing_context_suggestions.json?'+params,{credentials:'same-origin',signal:AbortSignal.timeout(5000)});
   if(!response.ok)return;
   const result=await response.json();
   const parts=result.suggestions?.[0]?.parts||{};
   const recommendedCountry=parts.country?.handle;
   let recommendedLanguage=parts.language?.handle;
   if(!valid(language,recommendedLanguage)){
    const available=[...language.options].map(option=>option.value);
    recommendedLanguage=(navigator.languages||[navigator.language]).map(value=>{
     const normalized=String(value||'').toLowerCase();
     return available.find(code=>code.toLowerCase()===normalized)||available.find(code=>code.toLowerCase()===normalized.split('-')[0]);
    }).find(Boolean);
   }
   const changeCountry=valid(country,recommendedCountry)&&recommendedCountry!==root.dataset.country;
   const changeLanguage=valid(language,recommendedLanguage)&&recommendedLanguage!==root.dataset.language;
   if(!changeCountry&&!changeLanguage)return;
   const suggestion=root.querySelector('.sb-localization-suggestion');
   const text=[];
   if(changeCountry)text.push([...country.options].find(option=>option.value===recommendedCountry).textContent);
   if(changeLanguage)text.push([...language.options].find(option=>option.value===recommendedLanguage).textContent);
   root.querySelector('[data-sb-suggestion-label]').textContent=text.join(' · ');suggestion.hidden=false;
   root.querySelector('[data-sb-review]').addEventListener('click',()=>{
    if(changeCountry)country.value=recommendedCountry;
    if(changeLanguage)language.value=recommendedLanguage;
    details.open=true;suggestion.hidden=true;country.focus();
   });
   root.querySelector('[data-sb-keep]').addEventListener('click',()=>{remember();suggestion.hidden=true});
  }catch{/* Leave native selectors usable when discovery fails. */}
 }
 const init=()=>{document.querySelectorAll('[data-sb-international]').forEach(preferences);document.querySelectorAll('[data-sb-occasion-guide]').forEach(guide)};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
